/* eslint-disable no-console */
import React, { useContext } from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../libs/Context';

const SelectDuration = (props) =>
{
	const { handleDuration, duration } = props;
	const { language } = useContext(LanguageContext);

	const chipData = [
		{ label: `1 ${language?.feedDay}`, id: 1 },
		{ label: `2 ${language?.day}s`, id: 2 },
		{ label: `1 ${language?.week}`, id: 3 },
		{ label: `2 ${language?.week}s`, id: 4 }

	];

	const handleSelect = (id: number) =>
	{
		handleDuration(id);
	};

	return (
		<>
			<Grid container px='var(--pixel8)' pt={3}>
				<Grid item xs={12}>
					<Typography variant='body1' fontWeight='var(--font500)'>Duration of poll availability</Typography>
				</Grid>
				<Grid item >
					<Stack direction='row' spacing={1} flexWrap='wrap' sx={{ pt: 1 }} >
						{chipData.map((chip) => (
							<Box key={chip.id} pb='var(--pixel8)'>
								<Button
									onClick={() => handleSelect(chip.id)}
									sx={{
										borderRadius    : '13px',
										border          : '1px solid var(--primaryColor)',
										backgroundColor : duration === chip.id ? 'var(--primaryColor)' : 'var(--primaryColor)33',
										color           : duration === chip.id ? 'var(--whiteColor)' : 'var(--primaryColor)',
										fontSize        : 'var(--pixel14)',
										fontWeight      : 400,
										textTransform   : 'none',
										height          : 'var(--pixel28)',
										cursor          : 'pointer',
										padding         : '0 16px',
										'&:hover'       : {
											backgroundColor : duration === chip.id ? 'var(--primaryColor)' : 'var(--primaryColor)33'
										}
									}}
								>
									{chip.label}
								</Button>
							</Box>
						))}
					</Stack>
				</Grid>
			</Grid>
		</>
	);
};

export default SelectDuration;
